/**
 * Add style to the document
 * @param {string} styleString
 */
export const addStyle = function (styleString) {
  var style = document.createElement("style");
  style.innerText = styleString;
  document.body.appendChild(style);
};
